export default () => ({
    title: '',
    content: '',
    button: {
        text: '',
        action: '',
    },
    link: {
        text: '',
        href: '',
    },

    close: {
        ['@click']() {
            this.$store.modalStore.close('alert');
        },
    },

    linkBind: {
        [':href']() {
            return this.link.href;
        },

        ['x-show']() {
            return this.link.text !== '';
        },

        ['x-text']() {
            return this.link.text;
        },
    },

    buttonBind: {
        ['@click']() {
            const modalStore = this.$store.modalStore;

            if (this.button.action === 'close') {
                modalStore.close('alert');
            }
            else {
                modalStore.open(this.button.action);
            }
        },

        ['x-show']() {
            return this.button.text !== '';
        },

        ['x-text']() {
            return this.button.text;
        }
    },

    open() {
        const data = this.$event.detail;

        for (let key in data) {
            this[key] = data[key];
        }

        this.$store.modalStore.open('alert');
    }
})
